import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react18-input-otp";
import loaderGif from "../../../assets/loaderGif.gif";
import successGif from "../../../assets/successGif.gif";
import SuccessSVG from "../../../assets/SuccessSVG.svg";
import Button from "../../../components/Buttons/Button";
import Header from "../../../components/Header";
import { height } from "../../../helpers/Constants";
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
import { routes } from "../../../helpers/Routes";
import Version from "../../../components/Version";
import ACCULogoSVG from "../../../assets/ACCULogoSVG.svg";
import msgIcon from "../../../assets/msgIcon/iPhone contact-text icon.png";
import alabamaOtpImg from "../../../assets/bankLogos/Alabama.svg";
import YodleeSVG from "../../../assets/YodleeSVG.svg";
import NinjaLogoSVG from "../../../assets/NinjaLogoSVG.svg";
import GLSVG from "../../../assets/GLSVG.svg";
import ArrowLoadingGif from "../../../assets/ArrowLoadingGif.gif";
import { toast } from "react-hot-toast";
import "../../../index.css";

const OTP = ({ setShowHeader }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { height, width } = useWindowDimensions();

  const [OTP, setOTP] = useState("");
  const [showOTP, setShowOTP] = useState(true);
  const [connectingToBank, setConnectingToBank] = useState(false);
  const [connectedToBank, setConnectedToBank] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current === false) {
      const otpNum = Math.round(900000 * Math.random()) + 100000;
      setTimeout(() => {
        toast.custom(
          <main
            onClick={() => {
              setOTP(otpNum);
              toast.dismiss();
            }}
            style={{
              background:
                "linear-gradient(140deg, #E6E9E6 0.87%, #C3C3C2 100.75%)",
            }}
            className="flex gap-3 rounded-[20px] text-blackText items-start px-[19px] py-[11px] cursor-pointer"
          >
            {/* <section className="max-w-[40px] w-[95px] h-[40px] rounded-full flex justify-center items-start bg-red-500 ">
            </section> */}
            {/* <section className="flex justify-center items-start bg-red-500 "> */}
            <img src={msgIcon} className="w-12 h-12" alt="" />
            {/* </section> */}

            <section className="px-[3.5px] flex flex-col">
              <div className="flex justify-between items-center">
                <div className="text-base font-semibold">74454</div>
                <div className="text-[10px] font-medium">now</div>
              </div>
              <div className="text-xs font-medium">
                Alabama Central Credit Union: Your secure access code is{" "}
                <span className="font-semibold">{otpNum}</span>. Do not share
                this code with anyone, we will never ask for it over the phone
                or by text.
              </div>
            </section>
          </main>
        );
      }, 250);
    }
    effectRan.current = true;
  }, []);

  useEffect(() => {
    if (resendTimer > 0) {
      setTimeout(() => {
        setResendTimer(resendTimer - 1);
      }, 1000);
    }
  }, [resendTimer]);

  const onContinueClick_Otp = () => {
    setShowHeader(false);
    if (OTP.toString().length === 6) {
      setShowOTP(false);
      setConnectingToBank(true);
      setTimeout(() => {
        setConnectingToBank(false);
        // console.log("first");
      }, 3000);
      setTimeout(() => {
        setConnectedToBank(false);
        setConnectedToBank(true);
        // console.log("second");
      }, 4000);
      setConnectedToBank(false);
      setTimeout(() => {
        navigate(routes.customerPortal);
      }, 6500);
    }
  };

  const otpToast = () => {
    setResendTimer(60);
    const otpNum = Math.round(900000 * Math.random()) + 100000;

    // setGenOtp(otpNum);
    setTimeout(() => {
      // toast.custom(
      //   <main
      //     onClick={() => {
      //       setOTP(otpNum);
      //       toast.dismiss();
      //     }}
      //     className="flex gap-3 w-fit bg-otpBg rounded-[20px] text-white items-center px-[19px] py-[11px]"
      //   >
      //     <section className="max-w-[40px] w-[95px] h-[40px] rounded-full flex justify-center items-center bg-white overflow-hidden">
      //       <img src={ACCULogoSVG} className="w-5 h-5" alt="" />
      //     </section>
      //     <section className="px-[3.5px] flex flex-col">
      //       <div className="flex justify-between items-center">
      //         <div className="text-base">74454</div>
      //         <div className="text-[10px]">now</div>
      //       </div>
      //       <div className="text-otpContentMsg text-xs">
      //         Alabama Central Credit Union: Do not share this code with anyone,
      //         we will never ask for it over the phone or by text. <br />
      //         Your secure access code is {otpNum}
      //       </div>
      //     </section>
      //   </main>
      // );
      toast.custom(
        <main
          onClick={() => {
            setOTP(otpNum);
            toast.dismiss();
          }}
          style={{
            background:
              "linear-gradient(140deg, #E6E9E6 0.87%, #C3C3C2 100.75%)",
          }}
          className="flex gap-3 rounded-[20px] text-blackText items-start px-[19px] py-[11px] cursor-pointer"
        >
          {/* <section className="max-w-[40px] w-[95px] h-[40px] rounded-full flex justify-center items-start bg-red-500 ">
          </section> */}
          {/* <section className="flex justify-center items-start bg-red-500 "> */}
          <img src={msgIcon} className="w-12 h-12" alt="" />
          {/* </section> */}

          <section className="px-[3.5px] flex flex-col">
            <div className="flex justify-between items-center">
              <div className="text-base font-semibold">74454</div>
              <div className="text-[10px] font-medium">now</div>
            </div>
            <div className="text-xs font-medium">
              Alabama Central Credit Union: Your secure access code is{" "}
              <span className="font-semibold">{otpNum}</span>. Do not share this
              code with anyone, we will never ask for it over the phone or by
              text.
            </div>
          </section>
        </main>
      );
    }, 3000);
  };

  return (
    <>
      <Header connectedToBank={connectedToBank} />

      <main
        className="px-6 h-full flex flex-col"
        style={{ height: `${height - 76}px` }}
      >
        {showOTP ? (
          <>
            <main className="flex-grow">
              <section className="text-center">
                {/* Alabama */}
                <section className="mt-5 mb-6">
                  <div className="flex items-center justify-center">
                    <img className="mr-3 w-12 h-9" src={ACCULogoSVG} />
                    <p className="text-left text-base font-medium">
                      Alabama Central
                      <br /> Credit Union
                    </p>
                  </div>
                </section>
                <section>
                  <div className="mb-4 text-blackText text-xl font-bold">
                    Authentication
                  </div>
                  {/* detail content */}
                  <p className="mt-1 mb-5 text-greySecondary text-sm">
                    Please enter the verification code
                    <br />
                    that was sent to XXX-XXX-3210
                  </p>
                  {/* OTP */}
                  <section className="my-5 flex items-center justify-center">
                    <OtpInput
                      className="otp-con mr-3 last:mr-0"
                      value={OTP}
                      onChange={(otp) => setOTP(otp)}
                      isInputNum={true}
                      numInputs={6}
                      // separator={<span className="font-bold ml-[5px]">-</span>}
                      separateAfter={3}
                      // onSubmit={console.log(OTP)}
                    />
                  </section>
                  {resendTimer === 0 ? (
                    <div
                      className="w-full mb-2 flex text-sm items-center justify-center underline text-primary font-medium cursor-pointer"
                      onClick={otpToast}
                    >
                      Resend Code
                    </div>
                  ) : (
                    <button className="w-full flex text-sm items-center justify-center text-blackText font-medium">
                      Resend in {resendTimer}s
                    </button>
                  )}
                </section>
              </section>
            </main>

            {/* Verify Passcode */}
            <section className="flex flex-col items-center justify-center">
              <Button
                name={"Verify Passcode"}
                route={""}
                isDisabled={OTP.toString().length === 6 ? true : false}
                onContinueClick_Otp={onContinueClick_Otp}
              />
              {/* Yodlee */}
              <section className="mt-4 flex items-center justify-center">
                <div className="mr-[5px] text-xs font-medium text-grey">
                  On behalf of NinjaFetch
                  <br /> data access provided by
                </div>
                <img className="w-16 h-8" src={YodleeSVG} />
              </section>
            </section>

            {/* <Version /> */}
          </>
        ) : null}
        {connectingToBank ? (
          <>
            <section className="flex flex-col flex-grow items-center justify-center">
              <div className="relative px-20 w-80 flex items-center justify-between">
                <img
                  src={GLSVG}
                  className="z-40 p-1 w-12 h-14 bg-white"
                  alt="GLSVG"
                />
                <div className="z-40 px-1 py-2 bg-white">
                  <img
                    src={ACCULogoSVG}
                    className="w-12 h-10 "
                    alt="ACCULogoSVG"
                  />
                </div>
                <div className="absolute z-30">
                  <img
                    src={ArrowLoadingGif}
                    className="rotate-45"
                    alt="ACCULogoSVG"
                  />
                </div>
              </div>
              <div className="z-40 mt-10 text-xl font-bold text-blackText text-center">
                Connecting to your
                <br />
                financial institution
              </div>
              {/* Yodlee */}
              <section className="mt-4 flex items-center justify-center">
                <div className="mr-[5px] text-xs font-medium text-grey">
                  On behalf of NinjaFetch
                  <br /> data access provided by
                </div>
                <img className="w-16 h-8" src={YodleeSVG} />
              </section>
            </section>
            {/* <Version /> */}
          </>
        ) : null}
        {connectedToBank ? (
          <>
            <section className="flex flex-col flex-grow items-center justify-center">
              <img
                src={SuccessSVG}
                className="w-[120px] h-[120px]"
                alt="success"
              />
              <div className="mt-4 mb-4 text-xl text-blackText text-center font-bold">
                Thank You!
              </div>
              <div className="text-sm text-greySecondary text-center font-medium">
                Your account was
                <br />
                successfully connected.
              </div>
              {/* <Button name={"Next Page"} /> */}
            </section>
            <section className="flex items-center justify-center">
              <div className="mr-[5px] text-xs font-medium text-greySecondary">
                Powered by
              </div>
              <img className="w-20 h-3" src={NinjaLogoSVG} />
            </section>
            {/* <Version /> */}
          </>
        ) : null}
      </main>
    </>
  );
};

export default OTP;

// import React, { useState } from "react";
// import OtpInput from "react18-input-otp";
// import { Link } from "react-router-dom";
// import "../../../index.css";

// function OTP() {
//   const [OTP, setOTP] = useState("");

//   return (
//     <main>
//       {/* Header */}
//       <h1 className="text-xl font-bold text-left my-2">Authentication Code</h1>

//       {/* detail content */}
//       <p className="text-gray-400 text-sm text-left my-2">
//         Please enter the verification code that was send to xxx-xxx-3210
//       </p>

//   {/* OTP */}
//   <div className="flex justify-start mt-5">
//     <OtpInput
//       value={OTP}
//       onChange={(otp) => setOTP(otp)}
//       numInputs={4}
//       // separator={<span className="font-bold ml-[5px]">-</span>}
//       separateAfter={3}
//       onSubmit={console.log(OTP)}
//       className="otp-con"
//     />
//   </div>

//   {/* resend code */}
//   <div className="">
//     <button
//       className="buttonTag"
//       style={{
//         color: OTP.length === 4 ? "#F5F5F5" : "#8F8F8F",
//         background: OTP.length === 4 ? "#4EA4E9" : "#E3E5E5",
//       }}
//     >
//       Verify Passcode
//     </button>
//     <br />
//     <Link href="#" className="underline text-primary font-medium">
//       Resend Code
//     </Link>
//   </div>
//     </main>
//   );
// }

// export default OTP;
